import type {FormAttributes} from "./attributes";
import type {FormData} from "./types";

type SuccessResult = {
    success: true;
    message: string;
}

type ErrorResult = {
    success: false;
    error: string;
}


export type SubmissionResult = SuccessResult | ErrorResult;


export async function submitForm(formData: FormData, attributes: FormAttributes): Promise<SubmissionResult> {
    const {
        nonce,
        rest_url
    } = attributes;

    try {
        const response = await fetch(rest_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': nonce,
            },
            body: JSON.stringify(formData),
        });

        if (!response.ok) {
            return {
                success: false,
                error: "Er is iets misgegaan bij het verzenden van het formulier. Probeer het later opnieuw."
            };
        }

        const result = await response.json();
        if (!result.success) {
            return {
                success: false,
                error: result.message || "Er is iets misgegaan bij het verwerken van het formulier. Probeer het later opnieuw."
            };
        }

        return {success: true, message: result.message};
    } catch (error) {
        console.error('Error submitting form:', error);
        return {
            success: false,
            error: "Er is een netwerkfout opgetreden. Controleer je verbinding en probeer het opnieuw."
        };
    }
}
